import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { OnVisible } from '@americanexpress/data-manager-utils';
import CancelButton from '../CancelButton';

export const OneCommercialPaymentsEnrollmentHeader = ({
  blueBoxLogoUrl, stackedLogoUrl, logoAltText, languageData, locale,
}) => (
  <OnVisible analyticsInfo={{ element: 'header' }}>
    <div>
      <div className="flex flex-justify-between flex-align-items-baseline dls-white-bg pad-1-t pad-1-b">
        <div className="margin-2-l">
          <span className="dls-logo-bluebox-solid-sm">
            <img src={blueBoxLogoUrl} alt={logoAltText} />
          </span>
          <span className="dls-logo-stack-md margin-2-l hidden-sm-down">
            <img src={stackedLogoUrl} alt={logoAltText} />
          </span>
          <span className="dls-logo-stack-sm margin-1-l hidden-md-up">
            <img src={stackedLogoUrl} alt={logoAltText} />
          </span>
        </div>
        <IntlProvider locale={locale} messages={languageData}>
          <CancelButton />
        </IntlProvider>
      </div>
      <div className="flex flex-column flex-align-center dls-gray-02-bg pad-1 heading-4-g" />
    </div>
  </OnVisible>
);

OneCommercialPaymentsEnrollmentHeader.propTypes = {
  blueBoxLogoUrl: PropTypes.string,
  stackedLogoUrl: PropTypes.string,
  logoAltText: PropTypes.string,
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack
  locale: PropTypes.string.isRequired,
};
export const loadModuleData = ({ store: { dispatch } }) => dispatch(loadLanguagePack('one-commercial-payments-enrollment-header', { fallbackLocale: 'en-US' }));

OneCommercialPaymentsEnrollmentHeader.holocron = {
  name: 'one-commercial-payments-enrollment-header',
  loadModuleData,
};

OneCommercialPaymentsEnrollmentHeader.defaultProps = {
  blueBoxLogoUrl: 'https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.24.1/package/dist/img/logos/dls-logo-bluebox-solid.svg',
  stackedLogoUrl: 'https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.24.1/package/dist/img/logos/dls-logo-stack.svg',
  logoAltText: 'American Express',
};

export default oneAppModuleWrapper('one-commercial-payments-enrollment-header')(OneCommercialPaymentsEnrollmentHeader);
